
export const shrink = v => {
  return {
    flexShrink: v
  }
}

export const grow = v => {
  return {
    flexGrow: v
  }
}

export const wrap = v => {
  return {
    flexWrap: v
  }
}